<template>
  <div>
    <dialog-create-from-template
      v-if="show"
      ref="templateSelectDialog"
      :itemsIntegrated="itemsIntegrated"
      :itemsOthers="itemsOthers"
      :itemsOthersTile="itemsOthersTile"
      :networkListInTileFormat="networkListInTileFormat"
      :read-article-url="`https://docs.bemob.com/${locale}/add-affiliate-network-from-templates`"
      :title="t('Affiliate network templates')"
      @confirm="getItem"
      @close="close"
    ></dialog-create-from-template>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { pick } from 'lodash';
import DialogCreateFromTemplate from '@/components/dialogs/dialog-create-from-template.vue';
import NETWORK_LIST_IN_TILE_FORMAT from '@/views/reports/forms/affiliate_network/network-list-in-tile-format';
import { getAffiliateNetworkTemplatesApiRequest } from '@/services/api/affiliate-networks-api';
import { useI18n } from '@/composables';
import { $emitter } from '@/services/emitter';
import { useStore } from '@/store';

type AffiliateNetworkTemplate = {
  id: string;
  name: string;
  main?: boolean;
  appendClickId?: boolean;
  clickIdPlaceholder?: string;
  payoutPlaceholder?: string;
  transactionIdPlaceholder?: string;
  statusPlaceholder?: string;
  clickIdParam?: string;
  postbackStatusConfirm?: string;
  postbackStatusNew?: string;
  postbackStatusDecline?: string;
  postbackStatusChargeback?: string;
  integrationType?: string;
};

const emit = defineEmits<{
  close: [];
}>();

const { t, locale } = useI18n();
const store = useStore();

const show = ref(false);
const templates = ref<AffiliateNetworkTemplate[]>([]);
const networkListInTileFormat = NETWORK_LIST_IN_TILE_FORMAT;

const itemPick = [
  'appendClickId',
  'clickIdPlaceholder',
  'payoutPlaceholder',
  'transactionIdPlaceholder',
  'statusPlaceholder',
  'clickIdParam',
  'postbackStatusConfirm',
  'postbackStatusNew',
  'postbackStatusDecline',
  'postbackStatusChargeback',
  'name',
  'main',
  'integrationType',
];

const itemsOthersTile = computed(() =>
  templates.value.filter((item) => networkListInTileFormat[item.name]),
);

const itemsOthers = computed(() =>
  templates.value.filter((item) => !item.main && !networkListInTileFormat[item.name]),
);

const itemsIntegrated = computed(() =>
  templates.value.filter((item) => item.main),
);

const getItem = (id: string) => {
  let item = templates.value.find((template) => template.id === id);

  if (item) {
    item = {
      ...pick(item, itemPick),
      templateId: item.id,
      usePostbackStatuses: !!(
        item.postbackStatusConfirm ||
        item.postbackStatusNew ||
        item.postbackStatusDecline ||
        item.postbackStatusChargeback
      ),
    };
  }

  close();
  $emitter.emit('open-dialog', {
    name: 'AffiliateNetworkDialog',
    data: { mode: 'create', ...(item || {}) },
  });
};

const close = () => {
  emit('close');
};

onMounted(async () => {
  store.setLoading(true);

  templates.value = (await getAffiliateNetworkTemplatesApiRequest()) as AffiliateNetworkTemplate[];
  show.value = true;

  store.setLoading(false);
});
</script>
